module.exports = __webpack_public_path__ + "img/jiajujizuo.prt.452c5000.jpg";